import BaseRailsRequestController from "./base_rails_request_controller";

// Connects to data-controller="dutch-autocomplete"
export default class extends BaseRailsRequestController {
  static values = {
    enabled: Boolean,
    endpointUrl: String,
    dutchCountryId: String,
    validPostalCodeCombationMessage: String,
  };

  static targets = [
    "countryInput",
    "countryResult",
    "postalCodeInput",
    "postalCodeResult",
    "houseNumberInput",
    "houseNumberResult",
    "localityInput",
    "localityResult",
    "administrativeAreaInput",
    "administrativeAreaResult",
    "locationInput",
    "locationResult",
    "result",
    "additionInput",
    "additionResult",
  ];

  updatedCountry(event) {
    this.enabledValue = event.target.value === this.dutchCountryIdValue;
  }

  throttledSearch() {
    if (!this.enabledValue) return;

    clearTimeout(this.timeout);

    const currentValue = this.postalCodeInputTarget.value.replace(/\s/g, "");

    if (currentValue.length !== 6) return;
    if (this.houseNumberInputTarget.value.length === 0) return;

    this.timeout = setTimeout(() => {
      this.search();
    }, 500);
  }

  search() {
    const url = new URL(this.endpointUrlValue, window.location.origin);

    url.searchParams.append("dutch_address[postal_code]", this.postalCodeInputTarget.value);
    url.searchParams.append("dutch_address[house_number]", this.houseNumberInputTarget.value);
    url.searchParams.append("dutch_address[addition]", this.additionInputTarget.value);

    this.fetchWithProgress("get", url, {
      responseKind: "json",
    })
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);

        return response.json;
      })
      .then((data) => {
        if (data.error) throw new Error(data.error);
        if (data.warning) {
          window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "warning", message: data.warning } }));
          return;
        }

        window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "success", message: this.validPostalCodeCombationMessageValue } }));

        this.populateFields(data);
      })
      .catch((error) => {
        console.error(error);
        window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "warning", message: error.message } }));
      });
  }

  populateFields({ city, province, street, house_number }) {
    const houseNumberParamPrefix = house_number.match(/^\d+/)?.[0] || ""; // First part of the house number (digits only)
    const houseNumberParamSuffix = house_number.replace(houseNumberParamPrefix, "");

    this.localityInputTarget.value = city;
    this.localityResultTarget.innerHTML = city;
    this.administrativeAreaInputTarget.value = province;
    this.administrativeAreaResultTarget.innerHTML = province;
    this.locationInputTarget.value = street;
    this.locationResultTarget.innerHTML = street;
    this.additionInputTarget.value = houseNumberParamSuffix || this.additionInputTarget.value;

    this.postalCodeResultTarget.innerHTML = this.postalCodeInputTarget.value;
    this.houseNumberResultTarget.innerHTML = this.houseNumberInputTarget.value;
    this.additionResultTarget.innerHTML = this.additionInputTarget.value;
    this.countryResultTarget.innerHTML = this.countryInputTarget.options[this.countryInputTarget.selectedIndex].text;

    this.resultTarget.classList.remove("invisible");
  }
}
